<div [ngClass]='["background", type]'></div>

<ng-container *ngIf="type === 'overlay'">
  <mat-card [ngClass]='["toolbox", type, displayTitle ? "w-title" : "wo-title"]'>
    <mat-card-header>
      <mat-card-title *ngIf="displayTitle">
        {{ 'i18n.toolbox.layout.title' | translate }}
      </mat-card-title>
      <mat-icon svgIcon="close"
                class="close-x"
                (click)="btnCancelClick()"></mat-icon>
    </mat-card-header>

    <mat-card-content *ngIf="templateGroups">
      <template-chooser
          [templateGroups]="templateGroups"
          [templatesSettings]="templatesSettings"
          [(selectedTemplateId)]="templateId"
          (selectedTemplateIdChange)="updateSelectedTemplateId($event)"
          [(selectedTemplateGroupId)]="templateGroupId"
          (selectedTemplateChange)="updateSelectedTemplate($event.templateGroupId, $event.templateId)"
          (selectedTemplateNotChange)="closeIfSmallOrMediumDevice()"
      ></template-chooser>
    </mat-card-content>
  </mat-card>
</ng-container>

<div class="toolbox-static" *ngIf="type === 'static'">
  <div class="header">
    <ng-container *ngIf="displayTitle">
      <span *ngIf="displayTitle" class="title">
        <mat-icon svgIcon="layouts"></mat-icon>
        {{ 'i18n.toolbox.layout.title' | translate }}
      </span>
      <hr class="title-hr" />
    </ng-container>
  </div>
  <div class="body" *ngIf="templateGroups">
    <template-chooser
        [templateGroups]="templateGroups"
        [templatesSettings]="templatesSettings"
        [(selectedTemplateId)]="templateId"
        (selectedTemplateIdChange)="updateSelectedTemplateId($event)"
        [(selectedTemplateGroupId)]="templateGroupId"
        (selectedTemplateChange)="updateSelectedTemplate($event.templateGroupId, $event.templateId)"
        (selectedTemplateNotChange)="closeIfSmallOrMediumDevice()"
    ></template-chooser>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/toolboxes/layout-toolbox/layout-toolbox.component.html